import React from "react";
import { Card, Row, Col, ProgressBar } from "react-bootstrap";
import { isMobile } from "react-device-detect";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { IconCup } from "../../../../assets/icons";

function CommentScore(props) {
  

  const SetColor = (rank) => {
    if (rank < 33) return "danger";
    else if (rank > 67) return "success";
    else return "warning";
  };

  const data = [
    {
      id: 1,
      title: "هیجان انگیز بودن",
      variantProgress: SetColor((100 / 5) * props.amusementService.isThriller),
      nowProgress: (100 / 5) * props.amusementService.isThriller,
      countScore: props.amusementService.isThriller,
    },
    {
      id: 2,
      title: "کیفیت خدمات",
      variantProgress: SetColor(
        (100 / 5) * props.amusementService.qualityServices
      ),
      nowProgress: (100 / 5) * props.amusementService.qualityServices,
      countScore: props.amusementService.qualityServices,
    },
    {
      id: 3,
      title: "ارزش خرید",
      variantProgress: SetColor((100 / 5) * props.amusementService.worthBuying),
      nowProgress: (100 / 5) * props.amusementService.worthBuying,
      countScore: props.amusementService.worthBuying,
    },
  ];

  return isMobile ? (
    <>
      <div className={"" + (!isMobile ? " pt-3" : " pb-3 ")}>
        {data.map((item) => (
          <Row className="mb-1 text-dark">
            <Col xs={5} lg={4} className={!isMobile ? " fs-09" : " fs-085"}>
              {item.title}
            </Col>
            <Col xs={5} lg className="my-auto px-1">
              <ProgressBar
                variant={item.variantProgress}
                now={item.nowProgress}
              />
            </Col>
            <Col
              xs="2"
              lg="1"
              className={
                (!isMobile ? " " : " text-small fw-bold") + " pr-0 text-center "
              }
            >
              {item.countScore}
            </Col>
          </Row>
        ))}
      </div>
    </>
  ) : (
    <>
      <Card className="rounded-3 shadow-sm border-0">
        <Card.Body>
          <div className="">
            <IconCup fillColor="black" />
            <h3 className="d-inline-block fw-bold fs-102  pb-3 pb-md-3 ps-2">
              امتیاز مسافران
            </h3>
          </div>
          <div className="">
            <Row>
              <Col md="auto " className="fs-103  my-auto">
                <div className=" px-5 text-secondary border-end border-secondary-subtle">
                  <div className="fs-085 text-center">امتیاز کلی</div>

                  <div>
                    <span className="fs-1 px-1 text-dark fw-bold ">
                      {props.amusementService.totalRank}
                    </span>
                    / 5
                  </div>
                </div>
              </Col>
              <Col md>
                {data.map((item) => (
                  <Row className="mb-1 text-dark px-4">
                    <Col
                      xs={5}
                      lg={3}
                      xl={2}
                      className={!isMobile ? " fs-09" : " fs-085"}
                    >
                      {item.title}
                    </Col>
                    <Col xs={5} xl lg className="my-auto px-1">
                      <ProgressBar
                        variant={item.variantProgress}
                        now={item.nowProgress}
                      />
                    </Col>
                    <Col
                      xs="2"
                      lg="1"
                      className={
                        (!isMobile ? " fw-bold fs-101" : " text-small") +
                        " pr-0 text-center "
                      }
                    >
                      {item.countScore}
                    </Col>
                  </Row>
                ))}
              </Col>
            </Row>
          </div>
        </Card.Body>
      </Card>
    </>
  );
}
export default CommentScore;
